const routes = {
  home: "/home",
  promotion: "/promotion",
  ordernow: "/ordernow",
  birthday: "/birthday",
  register: "/register",
  login: "/login",

  admin: "/admin",
  users: "/admin/users",
  products: "/admin/products",
  category: "/admin/category",

  information: "/information",
  shippingaddress: "/information/shipping-address",
  orderhistory: "/information/order-history",
  orderdetail: "information/order-history/orderdetail",
  wishlist: "/information/wish-list",

  chicken: "/ordernow/chicken",
  hamburger: "/ordernow/hamburger",
  ricepasta: "/ordernow/rice-pasta",
  dessert: "/ordernow/dessert",
  drink: "/ordernow/drink",

  checkout: "/checkout",
  pay: "/pay",
};

export default routes;
